<script>
import { headerMagasinProps, useHeaderMagasin } from "./mixin";
import ListItem from "@/components/molecules/list/list-item";
import List from "@/components/molecules/list";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import Divider from "@/components/atoms/divider";

export default {
  name: "MonMagasin",
  components: { Divider, Button, Icon, List, ListItem },
  props: {
    ...headerMagasinProps()
  },
  emits: ["selectShopClicked", "openPlanningPopin"],
  setup(props) {
    const { isOpened, showIfOpened } = useHeaderMagasin(props);
    return { isOpened, showIfOpened };
  }
};
</script>

<template>
  <div
    :class="{'c-header-mon-magasin--selected': !isNational }"
    class="c-header-mon-magasin"
  >
    <div
      v-if="isNational"
      class="u-text-center"
    >
      <div>
        <p class="u-font-16 u-font-700 u-font-secondary u-text-center u-mb-sm">
          Pensez à sélectionner votre magasin<br>
          ou votre point de retrait
        </p>

        <List class="u-font-14">
          <ListItem class="c-header-mon-magasin__advantage">
            <Icon
              name="check"
              size="sm"
              variant="success"
            /> Profitez des offres exclusives de votre magasin
          </ListItem>
          <ListItem class="c-header-mon-magasin__advantage">
            <Icon
              name="check"
              size="sm"
              variant="success"
            /> Consultez tous les produits disponibles
          </ListItem>
          <ListItem class="c-header-mon-magasin__advantage">
            <Icon
              name="check"
              size="sm"
              variant="success"
            /> Bénéficiez de tous les services de votre magasin
          </ListItem>
        </List>
        <p class="u-text-center u-mt-sm">
          <Button
            variant="primary"
            size="sm"
            radius="full"
            @click="$emit('selectShopClicked')"
          >
            Sélectionner mon magasin
          </Button>
        </p>
      </div>
    </div>
    <template v-else>
      <div class="u-mb-sm">
        <p class="u-font-16 u-font-700 u-font-secondary">
          {{ shopName }}
        </p>
        <template v-if="showIfOpened">
          <p
            v-if="isOpened"
            class="u-color-success  u-font-1"
          >
            Actuellement ouvert
          </p>
          <p
            v-else
            class="u-color-alert  u-font-1"
          >
            Actuellement fermé
          </p>
        </template>
      </div>
      <Divider />
      <template v-if="!isPro">
        <div class="u-mt-sm u-flex  u-mb-sm">
          <Icon
            name="shipping-drv"
            variant="primary"
            class="u-mr-xs"
          />
          <p class="u-font-13">
            Prochain créneau drive disponible<br>
            <template v-if="shopfirstSlotAvailable && shopfirstSlotAvailable!=='indisponible'">
              {{ shopfirstSlotAvailable }}<br>
            </template>
            <template v-else-if="shopfirstSlotAvailable && shopfirstSlotAvailable=='indisponible'">
              Aucun créneau n'est disponible pour le moment<br>
            </template>
            <Button
              class="u-mt-xxs"
              @click="$emit('openPlanningPopin')"
            >
              <span class="u-color-primary u-text-underline u-font-12">Voir le planning</span>
            </Button>
          </p>
        </div>
        <Divider />
      </template>
      <p class="u-mt-sm u-font-13">
        Rattaché au magasin<br>
        <span class="u-font-500">Cora {{ shopName }} </span>
      </p>
      <div class="c-header-mon-magasin__row-icon">
        <Icon
          name="location-outline"
          class="u-mr-xs"
          varian="grey-1"
        />
        <p class="u-font-12">
          {{ shopZipCode }} {{ shopCity }}<br>
          {{ shopAddress }}
        </p>
      </div>
      <div class="c-header-mon-magasin__row-icon">
        <Icon
          name="phone"
          class="u-mr-xs"
          varian="grey-1"
        />
        <p class="u-font-12">
          {{ shopPhone }}
        </p>
      </div>
      <Divider />
      <p class="u-mt-md u-text-center">
        <Button
          variant="primary"
          radius="full"
          size="sm"
          :to="`/magasins/${webAlias}-m-${shopId}`"
        >
          Voir la fiche magasin
        </Button>
      </p>

      <p class="u-mt-sm u-text-center">
        <Button
          link
          @click="$emit('selectShopClicked')"
        >
          Changer de magasin
        </Button>
      </p>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/header-mon-magasin.scss";
</style>
